import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

export interface ConfirmDialogProps {
  visible: boolean;
  title: string;
  message: string;
  icon?: {
    className: string;
    color: string;
  };
  onHide: () => void;
  onConfirm: () => void;
  isProcessing?: boolean;
  confirmButtonLabel?: string;
  confirmButtonClassName?: string;
  cancelButtonLabel?: string;
}

export function ConfirmDialog({
  visible,
  title,
  message,
  icon = {
    className: "pi pi-exclamation-triangle",
    color: "var(--davey-primary)",
  },
  onHide,
  onConfirm,
  isProcessing = false,
  confirmButtonLabel = "Yes",
  confirmButtonClassName = "p-button-secondary",
  cancelButtonLabel = "No",
}: ConfirmDialogProps) {
  const footer = (
    <>
      <Button
        label={cancelButtonLabel}
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
        disabled={isProcessing}
      />
      <Button
        label={confirmButtonLabel}
        icon="pi pi-check"
        className={confirmButtonClassName}
        onClick={onConfirm}
        loading={isProcessing}
      />
    </>
  );

  return (
    <Dialog
      header={title}
      visible={visible}
      style={{ width: "450px", maxWidth: "95vw" }}
      modal
      footer={footer}
      onHide={() => !isProcessing && onHide()}
      closable={!isProcessing}
      closeOnEscape={!isProcessing}
    >
      <div
        className="confirmation-content"
        style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}
      >
        <i
          className={icon.className}
          style={{ fontSize: "2rem", color: icon.color }}
          aria-hidden
        />
        <span>{message}</span>
      </div>
    </Dialog>
  );
}
